interface ColorTheme {
  accent: string;
  background: string;
  foreground: string;
}

const COLOR_THEMES: ColorTheme[] = [
  {
    accent: '#FFFFFF',
    background: '#340B0B',
    foreground: '#9B8FFF'
  },
  {
    accent: '#53E0FF',
    background: '#A80000',
    foreground: '#F2CCB7'
  },
  {
    accent: '#1F3077',
    background: '#FF8B8B',
    foreground: '#F9F8E6'
  },
  {
    accent: '#D120D1',
    background: '#E3E3E3',
    foreground: '#A68A73'
  },

  {
    accent: '#1A1A1A',
    background: '#F1D3D3',
    foreground: '#1539CF'
  },
  {
    accent: '#FFFFFF',
    background: '#28292B',
    foreground: '#E57066'
  },
  {
    accent: '#1539CF',
    background: '#FFEFE5',
    foreground: '#1FC8A9'
  },
  {
    accent: '#FFFFFF',
    background: '#050402',
    foreground: '#FAAC01'
  },

  {
    accent: '#FFFFFF',
    background: '#FFAD1E',
    foreground: '#2B86EB'
  },
  {
    accent: '#1539CF',
    background: '#EFE8D8',
    foreground: '#FF4552'
  },
  {
    accent: '#FFFFFF',
    background: '#EEB200',
    foreground: '#502F7E'
  },
  {
    accent: '#1A1A1A',
    background: '#FFD101',
    foreground: '#F000EF'
  },

  {
    accent: '#0B64C0',
    background: '#EED974',
    foreground: '#28292B'
  },
  {
    accent: '#01346D',
    background: '#FDF06F',
    foreground: '#D31B33'
  },
  {
    accent: '#FF4552',
    background: '#FFFDE7',
    foreground: '#189BA3'
  },
  {
    accent: '#1A1A1A',
    background: '#FBFE56',
    foreground: '#0B64C0'
  },

  {
    accent: '#FFFFFF',
    background: '#1B1D1C',
    foreground: '#EA1821'
  },
  {
    accent: '#FF4552',
    background: '#75FFC0',
    foreground: '#7A30CF'
  },
  {
    accent: '#FDF06F',
    background: '#17C37B',
    foreground: '#F4F4F4'
  },
  {
    accent: '#00FFCB',
    background: '#178E96',
    foreground: '#FDE3C8'
  },

  {
    accent: '#008FD3',
    background: '#BEF6E9',
    foreground: '#BB828B'
  },
  {
    accent: '#FBFE56',
    background: '#79DDF2',
    foreground: '#01346D'
  },
  {
    accent: '#FFFFFF',
    background: '#0C485E',
    foreground: '#FEB904'
  },
  {
    accent: '#FBFE56',
    background: '#3C485E',
    foreground: '#E9E8D4'
  },

  {
    accent: '#FFFFFF',
    background: '#083EA7',
    foreground: '#1FDE91'
  },
  {
    accent: '#CCFF01',
    background: '#0E38B1',
    foreground: '#FFFFFF'
  },
  {
    accent: '#FBFE56',
    background: '#121738',
    foreground: '#D17C78'
  },
  {
    accent: '#FFFFFF',
    background: '#864BFF',
    foreground: '#00FFCB'
  },

  {
    accent: '#7E08A7',
    background: '#F4C7EE',
    foreground: '#008FD3'
  },
  {
    accent: '#FFFFFF',
    background: '#4F3A4B',
    foreground: '#E75152'
  },
  {
    accent: '#FF4552',
    background: '#F8EBEE',
    foreground: '#0C3934'
  },
  {
    accent: '#FFFFFF',
    background: '#9879D0',
    foreground: '#FFD799'
  },

  {
    accent: '#FAFF00',
    background: '#1A1A1A',
    foreground: '#FFFFFF'
  },
  {
    accent: '#EB3197',
    background: '#FFFFFF',
    foreground: '#1A1A1A'
  }
];

const COLOR_THEME_PROPERTIES = ['accent', 'background', 'foreground'];

const getMatchingTheme = (
  theme: ColorTheme,
  userThemes: ColorTheme[]
): ColorTheme | null => {
  const themes = userThemes.concat(COLOR_THEMES);
  for (const t of themes) {
    if (t === theme) {
      return t;
    }
    if (
      theme.background.toLowerCase() === t.background.toLowerCase() &&
      theme.foreground.toLowerCase() === t.foreground.toLowerCase()
    ) {
      if (theme.accent.length > 0) {
        if (theme.accent.toLowerCase() === t.accent.toLowerCase()) {
          return t;
        }
      } else {
        return t;
      }
    }
  }
  return null;
};

const getUniqueThemes = (themes: ColorTheme[]): ColorTheme[] => {
  const map = {};
  const result: ColorTheme[] = [];
  themes.forEach(t => {
    const key = `${t.accent}-${t.background}-${t.foreground}`.toLowerCase();
    if (map[key] === undefined) {
      map[key] = t;
      result[result.length] = t;
    }
  });
  return result;
};

export {
  ColorTheme,
  COLOR_THEMES,
  COLOR_THEME_PROPERTIES,
  getMatchingTheme,
  getUniqueThemes
};



// WEBPACK FOOTER //
// ./src/data/ColorTheme.ts